import { render, staticRenderFns } from "./imgList.vue?vue&type=template&id=170a4f4f&scoped=true&"
import script from "./imgList.vue?vue&type=script&lang=js&"
export * from "./imgList.vue?vue&type=script&lang=js&"
import style0 from "./imgList.vue?vue&type=style&index=0&id=170a4f4f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170a4f4f",
  null
  
)

export default component.exports